var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_26967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8862 1.1459C10.6675 0.952669 10.3357 0.952669 10.1133 1.1459L0.196647 9.8959C-0.0439783 10.1074 -0.0694992 10.4792 0.145605 10.7199C0.360709 10.9605 0.728938 10.986 0.969563 10.7709L2.3331 9.56777V16.7501C2.3331 18.3615 3.63831 19.6667 5.24977 19.6667H15.7498C17.3612 19.6667 18.6664 18.3615 18.6664 16.7501V9.56777L20.03 10.7709C20.2706 10.9824 20.6388 10.9605 20.8539 10.7199C21.069 10.4792 21.0435 10.111 20.8029 9.8959L10.8862 1.1459ZM3.49977 16.7501V8.536L10.4998 2.35996L17.4998 8.536V16.7501C17.4998 17.7162 16.7159 18.5001 15.7498 18.5001H13.4164V12.6667C13.4164 12.0214 12.8951 11.5001 12.2498 11.5001H8.74977C8.10446 11.5001 7.5831 12.0214 7.5831 12.6667V18.5001H5.24977C4.28363 18.5001 3.49977 17.7162 3.49977 16.7501ZM8.74977 18.5001V12.6667H12.2498V18.5001H8.74977Z",
    fill: "#0270B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_26967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 18.6667,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHome);
export default __webpack_public_path__ + "static/media/Work-Home.072a492730c9a04c54264acb309f1b75.svg";
export { ForwardRef as ReactComponent };